var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system"},[_c('edition-title-bar'),_vm._l((_vm.dataArray),function(item,index){return _c('edition-cell',{key:index,attrs:{"model":item,"index":index,"isSelected":_vm.selectedIndex === index},on:{"onSelectClick":_vm.onCellSelectClick,"onCheck":_vm.onCheck,"onEditClick":_vm.onEditClick}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }